import { render, staticRenderFns } from "./CrftAddMain.vue?vue&type=template&id=2fc4cac9&scoped=true&"
import script from "./CrftAddMain.vue?vue&type=script&lang=js&"
export * from "./CrftAddMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc4cac9",
  null
  
)

export default component.exports